import React from "react";
import HighlightCheckIcon from "../icons/highlight-check";
import { useBrand } from "@/app/components/theme/brand-theme-boundary";
import { cn } from "@/lib/utils";

/**
 * HighlightTag
 *
 * Displays a highlighted feature with a check icon and styled background.
 * @param children The feature text to display
 */
const HighlightTag: React.FC<{ children: string }> = ({ children }) => {
  const { isAudi } = useBrand();

  return (
    <div
      className={cn(
        "bg-light-blue inline-flex items-center gap-2 rounded-md px-2 py-1 text-sm",
        isAudi &&
          "bg-primary text-primary-foreground rounded-md border-transparent"
      )}
    >
      <HighlightCheckIcon
        className={cn("text-primary h-6 w-6", isAudi && "text-white")}
      />
      {children}
    </div>
  );
};

export default HighlightTag;
